// The installed app's login (owner decision 30/10/2026, after OdeParfum's): the welcome screen's two doors, then one
// question per screen. The door says which flow it is, so nothing asks the server whether an email has an account.
// Steps live in the address (?flow=signup&step=2), so the phone's own back goes one question back.

export const FLOW_STEPS = {
  login: ['loginEmail', 'loginPassword'],
  signup: ['signupName', 'signupEmail', 'signupPassword', 'signupTerms'],
  forgot: ['forgotEmail', 'forgotSent'],
  signupSent: ['signupSent'],
};

// The fields each step validates before it can go on
export const STEP_FIELDS = {
  loginEmail: ['email'],
  loginPassword: ['password'],
  signupName: ['name'],
  signupEmail: ['email'],
  signupPassword: ['password', 'passwordConfirm'],
  signupTerms: ['terms'],
};

export const flowFromParam = (raw) =>
  Object.hasOwn(FLOW_STEPS, raw ?? '') ? raw : null;

/** The screen to show: the address's step, never past an earlier answer still missing (a reload loses the answers). */
export const stepOf = (raw, steps, values) => {
  const asked =
    Math.max(1, Math.min(steps.length, Number.parseInt(raw ?? '1', 10) || 1)) -
    1;
  for (let index = 0; index < asked; index += 1) {
    const missing = (STEP_FIELDS[steps[index]] || []).some(
      (field) => field !== 'terms' && !values[field]
    );
    if (missing) return index;
  }
  return asked;
};
